
import { defineComponent, PropType, toRefs, computed } from 'vue';
import { RouterLink } from 'vue-router';

import { GenreStyleModel } from '@/typings';

export default defineComponent({
    components: {
        RouterLink
    },
    props: {
        genre: {
            type: Object as PropType<GenreStyleModel>,
            required: true
        },
        full: {
            type: Number,
            required: true
        },
        hot: {
            type: Number,
            default: 0
        }
    },
    setup (props) {
        const {
            genre
        } = toRefs(props);
        const type = computed(() => {
            // 坑
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _type: any = genre.value.type;
            if (typeof _type === 'number') {
                return _type;
            }
            return _type.index;
        });

        const target_path = computed(() => {
            return type.value === 3 || type.value === 4 ? '/genres/style/' + genre.value.name_link : '/genres/genre/' + genre.value.name_link;
        });

        const name_class = computed(() => {
            return type.value === 3 || type.value === 4 ? 'style' : 'genre';
        });
        return {
            target_path,
            name_class
        };
    }
});

